module.exports = __webpack_public_path__ + "img/Überdachung.b66b43c3.jpg";